import { unwrapLoadCase } from './loadCase'

const CATEGORY_TO_DURATION: Record<LoadCategory, LoadDurationType> = {
  Live: 'Medium' as LoadDurationType,
  Dead: 'Constant' as LoadDurationType,
  Wind: 'ShortToVeryShort' as LoadDurationType,
  Snow: 'Short' as LoadDurationType,
  SnowPlus: 'Medium' as LoadDurationType,
  EarthQuake: 'VeryShort' as LoadDurationType,
}

const LIVE_LOAD_CASE_TO_DURATION: Record<string, LoadDurationType> = {
  LiveLoad_A1: 'Medium' as LoadDurationType,
  LiveLoad_A2: 'Medium' as LoadDurationType,
  LiveLoad_A3: 'Medium' as LoadDurationType,
  LiveLoad_B1: 'Medium' as LoadDurationType,
  LiveLoad_B2: 'Medium' as LoadDurationType,
  LiveLoad_B3: 'Medium' as LoadDurationType,
  LiveLoad_C1: 'Short' as LoadDurationType,
  LiveLoad_C2: 'Short' as LoadDurationType,
  LiveLoad_C3: 'Short' as LoadDurationType,
  LiveLoad_C4: 'Short' as LoadDurationType,
  LiveLoad_C5: 'Short' as LoadDurationType,
  LiveLoad_C6: 'Short' as LoadDurationType,
  LiveLoad_D1: 'Medium' as LoadDurationType,
  LiveLoad_D2: 'Medium' as LoadDurationType,
  LiveLoad_D3: 'Medium' as LoadDurationType,
  LiveLoad_E1: 'Long' as LoadDurationType,
  LiveLoad_E2: 'Medium' as LoadDurationType,
  LiveLoad_F1: 'Medium' as LoadDurationType,
  LiveLoad_F2: 'Short' as LoadDurationType,
  LiveLoad_H: 'Short' as LoadDurationType,
}

const DURATION_ORDER = {
  VeryShort: 0,
  ShortToVeryShort: 1,
  Short: 2,
  Medium: 3,
  Long: 4,
  Constant: 5,
} as const

const LOAD_DURATION_TYPE_LOOKUP: Record<LoadDurationType, string> = {
  VeryShort: 'sehr kurz',
  ShortToVeryShort: 'kurz/sehr kurz',
  Short: 'kurz',
  Medium: 'mittel',
  Long: 'lang',
  Constant: 'ständig',
}

export function getLoadDurationLabel(loadDuration: LoadDurationType): string {
  return LOAD_DURATION_TYPE_LOOKUP[loadDuration] || loadDuration
}

/** Load duration of a live load category with psi values of its own (not T1–T3 or Z). */
export function getLiveLoadDuration(loadCaseType: LoadCaseTypes): LoadDurationType {
  return LIVE_LOAD_CASE_TO_DURATION[loadCaseType]
}

export function getLoadDuration(loadCase: LoadCase): LoadDurationType {
  if (loadCase.category === 'Live') {
    return getLiveLoadDuration(loadCase.reference_load_case_type ?? loadCase.load_case_type)
  }
  return CATEGORY_TO_DURATION[loadCase.category]
}

export function getMinLoadDurationFromCombination(
  loadCaseCombination?: LoadCaseCombination,
): LoadDurationType {
  if (!loadCaseCombination) {
    return 'Long' as LoadDurationType
  }

  const loadCases = loadCaseCombination.data.map(([, , loadCase]) => unwrapLoadCase(loadCase))

  const durations = loadCases
    .map(getLoadDuration)
    .filter((duration): duration is LoadDurationType => duration !== undefined)

  if (durations.length === 0) {
    return 'Long' as LoadDurationType
  }

  return durations.reduce((minDuration, currentDuration) => {
    return DURATION_ORDER[currentDuration as keyof typeof DURATION_ORDER] <
      DURATION_ORDER[minDuration as keyof typeof DURATION_ORDER]
      ? currentDuration
      : minDuration
  }, durations[0])
}
